import { catchError } from "../../utils/Helper";
import { common } from "../axios/endpoint";
import { getRequest } from "../axios/request";

export const getFamilyList = async (query ,signal) => {
    try {
        const response = await getRequest(common.getFamilyList, query, signal);
        return response?.data;
    } catch (error){
        throw catchError(error);
    }
}

export const getSignedUrl = async (query ,signal) => {
    try {
        const response = await getRequest(common.getSignedUrl, query, signal);
        return response?.data;
    } catch (error){
        throw catchError(error);
    }
}

export const commonApi = {
    getFamilyList,
    getSignedUrl
}